__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@clusterio/controller";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@clusterio/lib", "2.0.2", () => (Promise.all([__webpack_require__.e(564), __webpack_require__.e(160), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(4754))))));
			register("@clusterio/web_ui", "2.0.2", () => (Promise.all([__webpack_require__.e(319), __webpack_require__.e(37), __webpack_require__.e(688), __webpack_require__.e(577)]).then(() => (() => (__webpack_require__(75))))));
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(844), __webpack_require__.e(319), __webpack_require__.e(935), __webpack_require__.e(688)]).then(() => (() => (__webpack_require__(8844))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(359)]).then(() => (() => (__webpack_require__(316))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(56), __webpack_require__.e(183), __webpack_require__.e(442), __webpack_require__.e(761)]).then(() => (() => (__webpack_require__(183))))));
			register("react-router", "6.30.6", () => (Promise.all([__webpack_require__.e(56), __webpack_require__.e(85), __webpack_require__.e(442)]).then(() => (() => (__webpack_require__(8085))))));
			register("react", "18.3.1", () => (__webpack_require__.e(155).then(() => (() => (__webpack_require__(4536))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};